import { FieldControllerProps } from '@dreryk/react-common';
import { Checkbox, ClassNameProp } from '@dreryk/react-components';

import { healthCareInstitutionTranslationKeys } from '../../../translations';

type SkipAddressInStampCheckboxProps = FieldControllerProps<'skipAddressInStamp', boolean> & ClassNameProp;

export const SkipAddressInStampCheckbox = (props: SkipAddressInStampCheckboxProps): JSX.Element => {
   const controller = props.register(props.name);

   return (
      <Checkbox
         testId={props.name}
         label={healthCareInstitutionTranslationKeys.healthcareProvider.practice.skipAddressInStamp}
         controller={controller}
         defaultValue={props.defaultValue}
      />
   );
};
